import Button from '@atoms/Button/Button';
import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import { IListingResult } from '@models/IListingResult';
import classNames from 'classnames';
import { Dispatch, PropsWithChildren, SetStateAction } from 'react';

interface Props {
  readonly loading: boolean;
  readonly results: IListingResult[];
  readonly error: boolean;
  readonly errorText: string;
  readonly noResultsText: string;
  readonly noResultsCTALabel: string;
  readonly setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
  readonly resultsClassName?: string;
  readonly loadingBackgroundClassName?: string;
  readonly noResultsClassName?: string;
  readonly errorClassName?: string;
}

const ListingResultsContainer = ({
  loading,
  results,
  error,
  errorText,
  noResultsText,
  noResultsCTALabel,
  setIsDrawerOpen,
  resultsClassName,
  loadingBackgroundClassName = 'bg-white/60 dark:bg-black-100/60',
  noResultsClassName,
  errorClassName,
  children,
}: PropsWithChildren<Props>) => {
  const hasResults = !!results?.length;

  return (
    <>
      {loading && !hasResults && (
        <LoadingSpinner extraClasses="min-h-[400px]" />
      )}

      {hasResults && !error && (
        <div className={classNames('relative', resultsClassName)}>
          {children}

          {loading && (
            <div
              className={classNames(
                'absolute inset-0 z-20 rounded',
                loadingBackgroundClassName
              )}
            >
              <LoadingSpinner extraClasses="min-h-[400px]" />
            </div>
          )}
        </div>
      )}

      {!hasResults &&
        !loading &&
        !error &&
        (noResultsText || noResultsCTALabel) && (
          <div
            className={classNames(
              'flex flex-col items-start justify-center gap-y-7.5 py-10 lg:gap-y-10',
              noResultsClassName
            )}
          >
            {noResultsText && <h3 className="lg:w-7/12">{noResultsText}</h3>}

            {noResultsCTALabel && (
              <Button
                onClick={() => {
                  setIsDrawerOpen(true);
                }}
              >
                {noResultsCTALabel}
              </Button>
            )}
          </div>
        )}

      {error && errorText && (
        <div className={classNames('py-10', errorClassName)}>
          <h3 className="lg:w-7/12">{errorText}</h3>
        </div>
      )}
    </>
  );
};

export default ListingResultsContainer;
